interface ResultAccordionBodyProps {
  children: React.ReactNode;
}

export const ResultAccordionBody = ({ children }: ResultAccordionBodyProps) => {
  return (
    <div className="result-accordion-body bg-slate-100/65 text-sm px-5 py-8 rounded-bl-md rounded-br-md flex flex-col gap-[3px] max-sm:py-5 max-sm:px-2">
      {children}
    </div>
  );
};
